<template>
    <v-dialog v-model="show" width="30%">
        <v-card id="cardModal" class="d-flex align-center justify-center flex-column">
            <v-card-text class="pa-0">
                <v-row>
                    <v-col cols="12" class="pb-2">
                        <v-row class="d-flex justify-center text-center headline primary--text font-weight-bold">
                            <v-icon class="ml-n4 mr-2" color="#FA4330">ph-warning-circle</v-icon>
                            <span> Atenção!</span>
                        </v-row>
                    </v-col>
                </v-row>
                <v-col class="d-flex align-center justify-center px-12 mb-4">
                    <v-divider color="#FA4300" />
                </v-col>
                <div class="primary--text text-center">
                    <h3>Proposta #{{ codigoProposta }} enviada para {{ reanalise ? 'Reanálise' : 'Análise' }}!</h3>
                </div>
                <v-col class="d-flex align-center justify-center px-12 mt-4">
                    <v-divider color="#FA4300" width="70%"/>
                </v-col>
            </v-card-text>
            <v-card-actions class="mb-4">
                <v-btn @click="close" class="text-center accent rounded-lg" width="98px">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
  data () {
    return {
      show: false,
      codigoProposta: '',
      model: {},
      reanalise: false
    }
  },
  methods: {
    openModal (sender, reanalise) {
      this.show = true
      this.model = sender
      this.codigoProposta = this.model.CodigoPropostaAN
      if (reanalise) { this.reanalise = true }
    },
    close () {
      this.show = false
      this.$emit('close', this.model)
    }
  }
}
</script>
<style>
  #cardModal {
    border: 1px solid #FA4300;
  }
</style>
